module.exports = __webpack_public_path__ + "static/media/mindfulness@2x.b6a1cf1c.png";